"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MtaSummaryPriceOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var PremiumOutputWidget_1 = require("./PremiumOutputWidget");
var commonFunctions_1 = require("../../commonFunctions");
var IPTDisclamer_1 = require("../../components/IPTDisclamer");
var components_1 = require("@athena-portal/components");
var services_1 = require("@falcon/services");
var MtaSummaryPriceOutputWidget = /** @class */ (function (_super) {
    __extends(MtaSummaryPriceOutputWidget, _super);
    function MtaSummaryPriceOutputWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showAdditionalPremium = function () {
            return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: "replace-car-price text-center", id: "price", children: (0, commonFunctions_1.getAmountToDisplay)(_this.props.interaction.factors.additionalPremium) }) }));
        };
        _this.showRefundPremium = function () {
            return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "replace-car-price text-center", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-center d-inline", children: (0, jsx_runtime_1.jsx)("b", { children: "Refund of " }) }), (0, jsx_runtime_1.jsx)("span", { id: "price", children: (0, commonFunctions_1.getAmountToDisplay)(_this.props.interaction.factors.returnPremium) })] }) }));
        };
        _this.showNoExtraPaymentForTheChange = function () {
            return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("p", { className: "text-center font-weight-bold", children: "Good news, there is no extra cost for the change you made!" }) }));
        };
        _this.showPremium = function () {
            var _a = _this.props.interaction.factors, returnPremium = _a.returnPremium, additionalPremium = _a.additionalPremium;
            if (returnPremium === 0 && additionalPremium === 0) {
                return _this.showNoExtraPaymentForTheChange();
            }
            else {
                if (additionalPremium && additionalPremium > 0) {
                    return _this.showAdditionalPremium();
                }
                if (returnPremium && returnPremium > 0) {
                    return _this.showRefundPremium();
                }
            }
            return;
        };
        _this.showPriceCouldGoUpOrDown = function () {
            var neverHigherAmount = (0, commonFunctions_1.getNeverHigherPeriodAmount)(_this.props.interaction);
            return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "section-panel", children: [_this.renderPriceSection(), (0, jsx_runtime_1.jsx)("p", { className: "text-center mx-4 mb-0", children: "Your price could go up or down, but we guarantee you won't pay more than" }), (0, jsx_runtime_1.jsx)("p", { className: "text-center font-weight-bold mx-4", children: (0, commonFunctions_1.getNeverHigherPeriodWording)(_this.props.interaction, neverHigherAmount, _this.state.policies) }), (0, jsx_runtime_1.jsx)(IPTDisclamer_1.default, { cssClass: "text-center mt-4 mx-4 mb-0" })] }) }));
        };
        _this.renderPriceSection = function () {
            var process = _this.props.interaction.process;
            if (process === services_1.INTERACTION_PROCESS_MTA_REINSTATE_CAR_COVER) {
                var vehicle = _this.props.interaction.vehicles[0];
                return ((0, jsx_runtime_1.jsxs)("div", { children: [_this.showPremium(), (0, jsx_runtime_1.jsxs)("p", { className: "text-center", children: ["to ", (0, jsx_runtime_1.jsxs)("b", { children: ["reactivate your car ", vehicle.make, ", ", vehicle.model] }), " (", vehicle.registrationNumber, ")"] })] }));
            }
            else if (process === services_1.INTERACTION_PROCESS_MTA_ADD_CAR) {
                var vehicle = _this.props.interaction.vehicles[0];
                return ((0, jsx_runtime_1.jsxs)("div", { children: [_this.showPremium(), (0, jsx_runtime_1.jsxs)("p", { className: "text-center", children: ["to add a car ", vehicle.make, ", ", vehicle.model, " (", vehicle.registrationNumber, ")"] })] }));
            }
            else if (process === services_1.INTERACTION_PROCESS_MTA_REINSTATE_RENTERS_COVER) {
                return ((0, jsx_runtime_1.jsxs)("div", { children: [_this.showPremium(), (0, jsx_runtime_1.jsx)("p", { className: "text-center", children: "to reactivate your renters cover" })] }));
            }
            else {
                return ((0, jsx_runtime_1.jsx)("div", { children: _this.showPremium() }));
            }
        };
        return _this;
    }
    MtaSummaryPriceOutputWidget.prototype.render = function () {
        if (this.state.policies && this.state.subscription) {
            return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: this.showPriceCouldGoUpOrDown() }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    return MtaSummaryPriceOutputWidget;
}(PremiumOutputWidget_1.PremiumOutputWidget));
exports.MtaSummaryPriceOutputWidget = MtaSummaryPriceOutputWidget;
//# sourceMappingURL=mtaSummaryPriceOutputWidget.js.map